const API_BASE = '/api/compliance/management-reports';

const getCsrfToken = () => document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/)?.[1] ?? '';

function getAuthHeaders(): HeadersInit {
  const token = sessionStorage.getItem('impersonation_token') || localStorage.getItem('token');
  if (!token) throw new Error('No authentication token found');
  return { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json', 'X-CSRF-Token': getCsrfToken() };
}

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Unknown error' }));
    throw new Error(err.error || err.message || `API Error: ${res.status}`);
  }
  return res.json();
}

export interface ManagementReport {
  id: number;
  company_id: number;
  generated_by: number;
  generated_by_name?: string;
  file_path: string;
  parameters?: Record<string, any>;
  created_at: string;
}

export const managementReportApi = {
  async list(companyId?: number): Promise<ManagementReport[]> {
    const q = companyId ? `?company_id=${companyId}` : '';
    const res = await fetch(`${API_BASE}${q}`, { headers: getAuthHeaders() });
    const result: any = await handleResponse(res);
    return result.data || result;
  },

  async generate(data: { company_id: number; parameters?: { include_risks?: boolean; include_policies?: boolean; include_capa?: boolean; include_tasks?: boolean } }): Promise<ManagementReport> {
    const res = await fetch(`${API_BASE}/generate`, { method: 'POST', headers: getAuthHeaders(), body: JSON.stringify(data) });
    const result: any = await handleResponse(res);
    return result.data || result;
  },

  downloadReport(id: number): void {
    const token = sessionStorage.getItem('impersonation_token') || localStorage.getItem('token');
    window.open(`${API_BASE}/${id}/download?token=${token}`, '_blank');
  },
};
